import { ValueOf } from '@/shared/lib/interfaces/utils';

export const FILTER_TYPE = {
	CUSTOM: 'custom',
	BUTTON: 'button',
	SELECT: 'select',
	DATE_RANGE: 'dateRange',
	INPUT: 'input',
	MULTISELECT: 'multiselect',
	CHECKBOX: 'checkbox',
} as const;

export type FilterType = ValueOf<typeof FILTER_TYPE>;
